export default "__VITE_ASSET__354bdb6a__"